import { render, staticRenderFns } from "./article-list.vue?vue&type=template&id=00b1e1db&scoped=true&"
import script from "./article-list.vue?vue&type=script&lang=js&"
export * from "./article-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b1e1db",
  null
  
)

export default component.exports